import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import CustomEase from 'gsap/CustomEase';
import { initGameLoopManager } from '../../../core/helpers/gameLoop';

export class GameView {
  constructor() {
    this.reelContainer = null;
    this.winContainer = null;
  }

  setContainers(reelContainer, winContainer) {
    this.reelContainer = reelContainer;
    this.winContainer = winContainer;
  }

  setupPixiPlugins() {
    gsap.registerPlugin(PixiPlugin, TextPlugin, CustomEase);
    PixiPlugin.registerPIXI(PIXI);
  }

  createCustomEases() {
    CustomEase.create(
      'customStopNormal',
      'M0,0 C0,0 0.553,0.856 0.746,1.046 0.79,1.09 0.802,1.066 0.83,1.057 1,1 1,1 1,1  '
    );

    CustomEase.create(
      'customStopTurbo',
      'M0,0 C0,0 0.232,0.89 0.259,0.938 0.282,0.979 0.337,1.071 0.364,1.098 0.388,1.123 0.426,1.136 0.452,1.147 0.477,1.157 0.534,1.169 0.567,1.165 0.639,1.157 1,1 1,1'
    );
  }

  initView(ticker) {
    this.setupPixiPlugins();
    this.createCustomEases();
    initGameLoopManager(ticker);
  }
}
